import React from 'react';

interface BrandMarkProps {
  /** Rendered box size in px (the mark is square) */
  size?: number;
  className?: string;
}

/**
 * The CustodyPlanner mark: an iris calendar tile whose page holds the two
 * parent-duo ribbons (violet + teal) sharing the month - same art as the
 * favicon and app icons so the identity is consistent everywhere.
 */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 34, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    className={className}
    role="img"
    aria-label="Custody Planner"
  >
    {/* Tile */}
    <rect x="0" y="0" width="32" height="32" rx="9" fill="#593EA3" />
    {/* Header band */}
    <path d="M0 9 h32 v6 H0 Z M0 9 a9 9 0 0 1 9-9 h14 a9 9 0 0 1 9 9 Z" fill="#493285" />
    {/* Binding rings */}
    <rect x="8" y="3.2" width="3" height="7.6" rx="1.5" fill="#3C2A6F" />
    <rect x="21" y="3.2" width="3" height="7.6" rx="1.5" fill="#3C2A6F" />
    {/* Parent-duo ribbons sharing the page */}
    <rect x="5.5" y="18" width="13" height="4.4" rx="2.2" fill="#CFC7EE" />
    <rect x="20.5" y="18" width="6" height="4.4" rx="2.2" fill="#7FD1C1" />
    <rect x="5.5" y="24.4" width="6" height="4.4" rx="2.2" fill="#7FD1C1" />
    <rect x="13.5" y="24.4" width="13" height="4.4" rx="2.2" fill="#CFC7EE" />
  </svg>
);

export default BrandMark;
